// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type CashRegisterPaymentFragment = { __typename?: 'CashRegisterPaymentDTO', amount: number | null, description: string | null, type: Types.CashRegisterPaymentTypeEnumDto };

export const CashRegisterPaymentFragment = gql`
    fragment CashRegisterPayment on CashRegisterPaymentDTO {
  amount
  description
  type
}
    `;
/* eslint-enable */